import React, { useState, useEffect } from "react";
import { Container, Col, Row } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import { apiCall } from "../../helpers/api";
import { useImageContext } from "../../hooks/useImageContext";
import { getImageUrl } from "../../helpers/images";
import { getSocialBadge } from "../../helpers/socials";
import { getSmallNumber } from "../../helpers/stats";
import Topbar from "../../components/topbar/Topbar";
import Footer from "../../components/footer/Footer";
import blueTick from './../../images/blue-tick.svg';
import Avatar from "./../../images/avatar.png";
import SmartImage from "../../components/images/SmartImage";

export default function MutedInfluencers() {
    const [mutedInfluencers, setMutedInfluencers] = useState([]);
    const { providers } = useImageContext();
    const [brand, setBrand] = useState({});

    useEffect(() => {
        // Fetch brand data
        apiCall(`brand`).then(res => {
            if (res && res.success && res.success.brand) {
                setBrand(res.success.brand);
            }
        });
        // Fetch muted influencers
        apiCall(`brand/mutedInfluencers`).then(res => {
            if (res && res.success && Array.isArray(res.success.mutedInfluencers)) {
                setMutedInfluencers(res.success.mutedInfluencers);
            } else {
                setMutedInfluencers([]);
            }
        }).catch(error => {
            setMutedInfluencers([]);
            console.error("Error fetching muted influencers:", error);
        });
    }, []);

    return (
        <div className="bg-page campaignsBrandFlow">
            <Topbar />
            <div className="pageName">Muted Influencers</div>
            <Container className="fullscreenWithTopBar px-0 campaignWall" fluid>
                <Container className="pageTitleContainer px-0 shadow-sm pb-0" fluid>
                    <Container className="border-bottom pb-0" fluid>
                        <Container className="px-0">
<Row className="px-3">
    <Col xs={6} className="mb-4 pt-4">
        <h1 className="pageTitle text-white m-0 tragedyRegularFont ps-md-0">
            <div className="d-flex align-items-center">
                <SmartImage src={getImageUrl(providers, brand.profileImage, ["w_100","c_scale"])} height="36px" width="36px" className="object-fit-cover rounded border me-2 border-gray bg-white p-1" />
                <div className="text-truncate">{brand && brand.name}</div>
            </div>
        </h1>
    </Col>
    <Col xs={6} className="d-flex justify-content-end align-items-stretch my-4">
        <div className="fw-normal text-primary bg-light py-2 px-3 rounded">
            <span className="fs-6">Total Influencers: </span>
            <span className="fw-500 fs-6">{mutedInfluencers && mutedInfluencers.length}</span>
        </div>
    </Col>
</Row>
                        </Container>
                    </Container>
                </Container>
                
                <Container fluid className="brandCommunity">
                    <Container className="px-0 mb-8">
                        <Row className="px-3">
                            <Col md={12}>
                                <div className="pt-md-4">
                                    {/* Muted Influencers Section */}
                                    <div className="mb-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h3 className="mb-0">Muted Influencers</h3>
                                        </div>
                                        
                                        {mutedInfluencers.length === 0 ? (
                                            <div className="text-center py-5">
                                                <div className="text-muted">No muted influencers.</div>
                                                <div className="text-muted small">
                                                    Influencers you mute will appear here.
                                                </div>
                                            </div>
                                        ) : (
                                            <Row>
                                                {mutedInfluencers.map((member) => (
                                                    <Col xs={12} md={6} lg={4} xl={4} key={member._id} className="mb-4">
                                                        <div className="panel w-100 bg-light d-flex align-items-start justify-content-start rounded position-relative p-3">
                                                            <div className="me-3">
                                                                <SmartImage 
                                                                    src={getImageUrl(providers, member.profileImage, ["w_100", "c_scale"])} 
                                                                    fallbackSrc={Avatar}
                                                                    height="120px" 
                                                                    width="120px" 
                                                                    className="object-fit-cover rounded border me-2" 
                                                                    alt={member.name}
                                                                />
                                                            </div>
                                                            <div className="w-75">
                                                                <h5 className="mb-2 mt-1 text-capitalize text-truncate text-nowrap me-2">
                                                                    {member.name || 'Unnamed Influencer'}
                                                                </h5>
                                                                <Row>
                                                                    <Col>
                                                                        <div className="text-muted small mb-2 pb-1">
                                                                            Country - <span className="fw-bold">{member.country || 'Unknown'}</span>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    {member.socials && member.socials.filter(social => social.name !== "meta").map((social, socialIndex) => (
                                                                        <React.Fragment key={`${social.name}-${socialIndex}`}>
                                                                            <Col>
                                                                                <div className="d-flex align-items-start">
                                                                                    {getSocialBadge(social.name, null, "20px", "colour", social.handle)}
                                                                                    {(social.data?.isVerified) && (
                                                                                        <img src={blueTick} className="blueTick ms-1" alt="Verified" />
                                                                                    )}
                                                                                    <div className="ms-1">
                                                                                        <div className="text-muted smaller">
                                                                                            {(social.data?.followers > 0 && getSmallNumber(social.data.followers)) || ""}
                                                                                        </div>      
                                                                                        {social.data?.engagementRate > 0 ? (
                                                                                            <Badge bg="info" className="small">
                                                                                                {social.data.engagementRate.toFixed(2)}%
                                                                                            </Badge>
                                                                                        ) : ""}    
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                        </React.Fragment>
                                                                    ))}
                                                                </Row>
                                                                {/* Muted Badge */}
                                                                <div className="mt-2">
                                                                    <Badge bg="danger" className="small">
                                                                        Muted
                                                                    </Badge>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                ))}
                                            </Row>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </Container>
            <Footer />
        </div>
    );
}